import DDLogs from '@/DDLogs';
import IlReFinanceStoryLibAdapter from './IlReFinanceStoryLibAdapter.vue';

function initializeIlReFinanceIntegration() {
  if (typeof window === 'undefined') {
    return;
  }

  if (!window.IlReFinanceComponentRegistry) {
    setTimeout(() => {
      initializeIlReFinanceIntegration();
    }, 100);
    return;
  }

  try {
    window.IlReFinanceComponentRegistry.register(IlReFinanceStoryLibAdapter);
  } catch (error) {
    DDLogs.error('Failed to register IlReFinance component', { error });
  }
}

if (typeof window !== 'undefined') {
  setTimeout(() => {
    initializeIlReFinanceIntegration();
  }, 0);
}
